import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ProjectAiSummary } from './project-ai-summaries.model';

export interface GenerateProjectAiSummaryOptions {
  readonly id?: number;
  readonly projectId?: number;
  readonly text?: string;
}

export interface GenerateProjectAiSummariesOptions {
  readonly summaries: readonly GenerateProjectAiSummaryOptions[];
}

export function generateProjectAiSummaryObject({
  id = generateId(),
  projectId = generateId(),
  text = 'This project is looking for a skilled web developer to build a responsive website using React and Node.js. The ideal candidate should have experience with front-end and back-end development, as well as a strong portfolio of previous work.',
}: GenerateProjectAiSummaryOptions): ProjectAiSummary {
  return {
    id,
    projectId,
    text,
  };
}

export function generateProjectAiSummaryObjects({
  summaries,
}: GenerateProjectAiSummariesOptions): readonly ProjectAiSummary[] {
  return summaries.map(summary => {
    return generateProjectAiSummaryObject({
      ...summary,
    });
  });
}
